import React from 'react';
import { InputField } from 'components/form';
import { useFormContext } from 'react-hook-form';

export const OptionsTableFilters = () => {
  const { control } = useFormContext();

  return (
    <InputField
      control={control}
      name="search"
      label="Search by code, name, or description"
      inputProps={{ variant: 'outlined' }}
    />
  );
};
